import styled from 'styled-components'
import { colorTheme } from '../../../../../style/theme/colorTheme'

export const OrderUnpaidWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
`
OrderUnpaidWrapper.displayName = 'OrderUnpaidWrapper'

export const OrderUnpaidContent = styled.div`
	display: flex;
	align-items: center;
	gap: 0.5em;

	> svg {
		width: 1.31em;
		height: 1.31em;
		fill: ${colorTheme.table.tableTr.dangerText};
	}
`
OrderUnpaidContent.displayName = 'OrderUnpaidContent'

export const OrderUnpaidText = styled.div`
	color: ${colorTheme.table.tableTr.dangerText};
	font-size: 0.8em;
`
OrderUnpaidText.displayName = 'OrderUnpaidText'


export const DriverPaymentContent = styled.div`
	display: flex;
	align-items: center;
	gap: 0.5em;

	> svg {
		width: 1.31em;
		height: 1.31em;
		fill: ${colorTheme.table.tableTd.icon};
	}
`
DriverPaymentContent.displayName = 'DriverPaymentContent'

export const DriverPaymentText = styled.div`
	align-self: flex-start;
	margin-top: 0.35em;
	padding: 0.2em 0.7em;
	border-radius: 1em;
	font-size: 0.8em;
	font-weight: 500;
	white-space: nowrap;
	background: ${colorTheme.table.tableTr.pendingBadgeBg};
	color: ${colorTheme.table.tableTr.pendingText};

	&.paid {
		background: ${colorTheme.table.tableTr.successBadgeBg};
		color: ${colorTheme.table.tableTr.successText};
	}
`
DriverPaymentText.displayName = 'DriverPaymentText'
